import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, catchError, Observable } from 'rxjs';
import { Transaction, PaginatedResponse, TranscationQuery } from '../models/transaction.model';
import { environment } from '../../../../environments/environment';
import { Agency } from '../models/agency.model';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    private readonly apiUrl = `${environment.apiURL}/transactions`;

    constructor(private readonly http: HttpClient) { }

    getTransactions(pageIndex: number, pageSize: number, filter: TranscationQuery): Observable<PaginatedResponse<Transaction>> {
        const payload = {
            ...filter
        };
        const params = {
            pageIndex: pageIndex.toString(),
            pageSize: pageSize.toString()
        };
        return this.http.post<PaginatedResponse<Transaction>>(`${this.apiUrl}/search`, payload, { params });
    }

    getIssuingAgents(search?: string): Observable<Agency[]> {
        let params = new HttpParams();
        if (search && search.length >= 3) {
            params = params.set('search', search);
        }
        return this.http.get<Agency[]>(`${this.apiUrl}/issuing-agents`, { params });
    }


    createTransaction(payload: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, payload);
    }

    deleteTransaction(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete<any>(url);
    }

    resendEmail(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/resend-email`;
        return this.http.post(url, null);
    }

    resendSms(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/resend-sms`;
        return this.http.post(url, null);
    }

    getIdentityVerificationReport(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}/report`;
        return this.http.get(url, { responseType: 'blob' })
            .pipe(catchError(this.handleBlobError))
    }

    private readonly handleBlobError = (error: HttpErrorResponse): Observable<never> => {
        if (error.error instanceof Blob && error.error.type === 'application/problem+json') {
            return new Observable(observer => {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const problem = JSON.parse(reader.result as string);
                        observer.error(problem); // Emit parsed error
                    } catch (e) {
                        observer.error({ title: 'Unexpected Error', detail: 'Could not parse error response.' });
                    }
                    observer.complete();
                };

                reader.onerror = () => {
                    observer.error({ title: 'File Read Error', detail: 'Could not read error response blob.' });
                    observer.complete();
                };

                reader.readAsText(error.error);
            });
        }

        // For non-Blob or unknown error types
        return throwError(() => error);
    };
} 